import type { CategoryAssignment, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'categories/assignments';

export function getCategoryAssignments(query: CategoryAssignment.SearchQuery) {
    return api.get<Pagination<CategoryAssignment>>(rootPath, query);
}

export function getCategoryAssignment(id: number) {
    return api.get<CategoryAssignment.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postCategoryAssignment(data: CategoryAssignment.CreateRequest) {
    return api.post<CategoryAssignment>(rootPath, data);
}

export function putCategoryAssignment(
    id: number,
    data: CategoryAssignment.UpdateRequest
) {
    return api.put<CategoryAssignment>(`${rootPath}/${id}`, data);
}

export function deleteCategoryAssignment({
    id,
}: CategoryAssignment.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
